import { CancelButtons } from "@/app/(application)/(normal)/account/components/cancelSubscriptionLink/cancelSubscriptionModal/CancelButtons";
import { NormalText } from "@/components/text/NormalText";
import { type OfferedDiscount } from "@/types/types";

export function DiscountOffer({
  title,
  offeredDiscount,
  onAccept,
  onReject,
}: {
  title: string;
  offeredDiscount: OfferedDiscount | null;
  onAccept: () => void;
  onReject: () => void;
}) {
  return (
    <div className="space-y-4">
      <NormalText elementType="p">{title}</NormalText>
      {offeredDiscount !== null && (
        <div className="flex items-center justify-center rounded-3xl bg-gray-100 px-8 py-4 shadow-sm ring-1 ring-gray-900/5">
          <NormalText elementType="p" className="text-lg font-normal">
            🎉 {offeredDiscount.terms} 🎉
          </NormalText>
        </div>
      )}
      <CancelButtons
        positiveText="Accept discount"
        negativeText="Continue with cancellation"
        onPositive={onAccept}
        onNegative={onReject}
      />
    </div>
  );
}
